import React, { useState, useEffect } from 'react';
import {
  PageHeader, Descriptions, Divider, Row, Space, Button
} from 'antd';
import PropTypes from 'prop-types';
import { ArrowLeftOutlined, ExperimentOutlined } from '@ant-design/icons';
import Breadcrumb from 'components/BreadCrumb';
import {
  fetchTheme, fetchSubTheme, getFullTheme
} from 'utils/themes';
import renderCode from 'components/codes';
import Skeleton from 'components/Spins/Skeleton';
import { fetchRecipe, gerRecipeIngredients } from 'utils/recipes';

const RecipeDetails = (props) => {
  const [recipe, setRecipe] = useState({});
  const [themes, setThemes] = useState([]);
  const [subThemes, setSubThemes] = useState([]);

  useEffect(() => {
    const { match: { params: { recipeId } } } = props;
    fetchTheme().then(themesData => {
      setThemes(themesData);
      fetchSubTheme().then(subThemesData => {
        setSubThemes(subThemesData);
        if (recipeId) {
          fetchRecipe(recipeId)
            .then((recipeData) => {
              setRecipe(recipeData);
            });
        } else {
          const { recipeFromProps } = props;
          if (recipeFromProps) {
            setRecipe(recipeFromProps);
          }
        }
      });
    });
  }, []);

  const getThemeHtml = (theme, subTheme, lasttree = null) => {
    const fullThemeName = getFullTheme(themes, subThemes, theme, subTheme, lasttree);
    if (!fullThemeName) return false;
    return (
      <ul>
        {fullThemeName.map(name => (
          <li key={name}>
            {name}
          </li>
        )
        )}
      </ul>
    );
  };

  const getContentOrSpinner = () => {
    if (!recipe) {
      return (
        <Skeleton />
      );
    }
    const { history: { push } } = props;
    return (
      <>
        {recipe && recipe.name && (
        <Divider>
          <ExperimentOutlined />
          {` Recette ${recipe?.name}`}
        </Divider>
        )}
        {recipe && recipe.ingredients && gerRecipeIngredients(recipe.ingredients).map((ing, index) => {
          const themeName = getThemeHtml(ing.theme, ing.subtheme, ing?.lasttree);
          return (
            <>
              <Descriptions
                bordered
                title={`Ingrédients ${index + 1}`}
                style={{ marginBottom: '20px' }}
              >
                <Descriptions.Item key={ing.ingredient} label="Nom" span={3}>{ing.ingredient}</Descriptions.Item>
                <Descriptions.Item key={ing.theme} label="Thème" span={3}>{themeName}</Descriptions.Item>
                {ing.condition && (
                  <Descriptions.Item key={ing.condition} label="PH" span={3}>{ing.condition}</Descriptions.Item>
                )}
                {ing.code && ing.code.map(code => (
                  <>
                    <Descriptions.Item key={code.letters.code} label="Code" span={1}>{code.letters.code}</Descriptions.Item>
                    <Descriptions.Item key={code.letters.condition} label="Condition" span={2}>{code.letters.condition}</Descriptions.Item>
                  </>
                ))}
              </Descriptions>
            </>
          );
        })}
        {recipe && (renderCode(recipe))}
        <Row justify="center" type="flex">
          <Space wrap align="start" size="large" style={{ marginTop: '20px' }}>
            <Button type="primary" onClick={() => push('/recipes')} icon={<ArrowLeftOutlined />}>Liste des recettes</Button>
          </Space>
        </Row>
      </>
    );
  };

  return (
    <>
      <PageHeader
        style={{ border: '1px solid #d9d9d9' }}
        title={recipe?.name}
        breadcrumb={(
          <Breadcrumb
            items={[
              ['Accueil', '/'],
              ['Mes recettes', '/recipes'],
              [`${recipe?.name}`],
            ]}
          />
        )}
      />
      {getContentOrSpinner()}
    </>
  );
};

RecipeDetails.propTypes = {
  recipe: PropTypes.shape({
    name: PropTypes.string,
    userId: PropTypes.string,
    ingredients: PropTypes.shape({
      condition: PropTypes.string,
      ingredient: PropTypes.string,
      themes: PropTypes.string
    })
  }),
  recipeFromProps: PropTypes.shape({
    name: PropTypes.string,
    userId: PropTypes.string,
    ingredients: PropTypes.shape({
      condition: PropTypes.string,
      ingredient: PropTypes.string,
      themes: PropTypes.string
    })
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      recipeId: PropTypes.string
    })
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  })
};

export default RecipeDetails;
